<template>
    <dialogs-base :show.sync="dialog" :max-width="maxWidth" :scrollable="scrollable" :max-height="maxHeight">
        <template v-slot:body>

            <v-card :loading="isLoading">

                <v-card-title class="grey--text text--darken-3 grey lighten-2 py-1 text-subtitle-2 font-weight-regular">
                    <slot name="title">{{ title }}</slot>
                    <v-spacer></v-spacer>
                    <slot name="tools"></slot>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon small class="mr-1" @click.native="dialog = false" :disabled="isLoading" v-bind="attrs" v-on="on">
                                <v-icon color="red lighten-2">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Fechar</span>
                    </v-tooltip>
                </v-card-title>

                <v-card-text class="mt-4">
                    <slot name="form" />
                </v-card-text>

                <v-card-actions>
                    <small class="text-caption" v-if="!hideButton && !isDisabledButton">*Campos obrigatórios</small>
                    <v-spacer></v-spacer>
                    <slot name="actions"></slot>
                    <slot name="save">
                        <v-btn v-if="!hideButton" small color="primary" :disabled="isDisabledButton" @click="save()" :loading="isLoading">
                            {{ saveLabel ? saveLabel : (params.id ? `Atualizar` : `Cadastrar`) }}
                            <v-icon small right dark>mdi-content-save</v-icon>
                        </v-btn>
                    </slot>
                </v-card-actions>
                
            </v-card>

        </template>
    </dialogs-base>
</template>

<script setup>

import { ref, computed, defineProps, defineEmits } from 'vue'
import { useStore } from '@/composables/useStore'

const emit = defineEmits(['update:show'])

const props = defineProps({
    show: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    persistent: { type: Boolean, default: false },
    maxHeight: { type: String, default: 'auto' },
    maxWidth: { type: String, default: "80%" },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: "Título" },
    errors: { type: Object, default: () => ({}) },
    message: { type: String, default: null },
    storeAction: { type: String, required: false },
    params: { type: Object, default: () => ({}) },
    noCloseCreated: { type: Boolean, default: false },
    disableButton: { type: Boolean, default: false },
    hideButton: { type: Boolean, default: false },
    saveLabel: { type: String, default: null },
});

const isLoading = ref(false)

const dialog = computed({
    get() {
        return props.show
    },
    set(value) {

        // Limpando variáveis importantes sempre que o dialog for fechado
        if(!value) {
            isLoading.value = false
            stringMessage.value = null
            objectErrors.value  = {}
        } 

        emit('update:show', value)
    }
})

const store = useStore()

const ActionRequest = (params) => store.dispatch(props.storeAction, params)

const objectErrors = computed({
    get() {
        return props.errors
    },
    set(value) {
        emit('update:errors', value)
    }
})

const isDisabledButton = computed(() => {
    return props.disableButton || isLoading.value
})

const stringMessage = computed({
    get() {
        return props.message
    },
    set(value) {
        emit('update:message', value)
    }
})

function save() {
    
    isLoading.value = true

    const params = {
        ...props.params
    }

    try {
        ActionRequest(params)
            .then((res) => {
                dialog.value = false
                emit('onSuccessfully', res.data)
            })
            .catch((error) => {
                stringMessage.value = error.message
                objectErrors.value  = error.errors
            })
            .finally(() => {
                isLoading.value = false
            })

    } catch (error) {
        stringMessage.value = "Erro ao tentar executar a requisição [" + props.storeAction + "]." 
        objectErrors.value  = error
        isLoading.value = false
    }
}

</script>
